import { render, staticRenderFns } from "./2.vue?vue&type=template&id=473a9b67&scoped=true&"
var script = {}
import style0 from "./2.vue?vue&type=style&index=0&id=473a9b67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473a9b67",
  null
  
)

export default component.exports